export class OrganizationSubjects {
  static Entity = 'entity'
  static Fiz = 'fiz'
  static Individual = 'individual'
  static Terminal = 'terminal'
  static Foreign = 'foreign'
}
